'use client';

import SectionHeader from '@/app/(website)/components/SectionHeader';
import CheckFat from '@/assets/icons/CheckFat.svg';
import {Body} from '@/components/body';
import {useEffect, useRef, useState} from 'react';

const reasons = [
  'Per fare più in fretta la prima ricerca e arrivare prima al punto giuridico rilevante.',
  'Per costruire una prima bozza migliore senza partire ogni volta da una pagina bianca.',
  'Per leggere più rapidamente fascicoli e allegati e trasformare materiale dispersivo in sintesi operative.',
  'Per supportare collaboratori e praticanti con una base di lavoro più ordinata e guidata.',
  'Per mantenere il controllo professionale perché la decisione finale resta sempre dell\'avvocato.',
];

export default function WhyLegal() {
  const [isVisible, setIsVisible] = useState(false);
  const listRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {threshold: 0.2},
    );

    if (listRef.current) {
      observer.observe(listRef.current);
    }

    return () => {
      if (listRef.current) {
        observer.unobserve(listRef.current);
      }
    };
  }, []);

  return (
    <div id="pricing" className="w-full md:px-8 py-16">
      <div className="flex flex-col items-center justify-center md:rounded-2xl px-4 py-16 gap-3">
        <SectionHeader
          badgeText="Perché sceglierlo"
          title="Perché uno studio legale lo usa davvero"
          subtitle=""
        />
        <ul
          ref={listRef}
          className="flex flex-col gap-5 max-w-[56.625rem] w-full"
        >
          {reasons.map((reason, index) => (
            <li
              key={index}
              className={`flex items-start gap-4 transition-all duration-700 ease-in-out transform ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{transitionDelay: `${index * 120}ms`}}
            >
              <span className="mt-1 shrink-0 text-secondary">
                <CheckFat width={24} height={24} />
              </span>
              <Body variant="large">{reason}</Body>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
